/**
 * Overall number of cards shown in the section, sales and trade-ins combined.
 * Replacement groups at the cutoff may make the actual number higher.
 */
export const MAX_VISIBLE_CARDS = 6

export const WEEKDAY_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
}

export function compareByDateDesc(
  a: { sortDate: Date | null },
  b: { sortDate: Date | null },
): number {
  const aTime = a.sortDate?.getTime() ?? Number.NEGATIVE_INFINITY
  const bTime = b.sortDate?.getTime() ?? Number.NEGATIVE_INFINITY

  return bTime - aTime
}
